import React from "react";
import BigNumber from "bignumber.js";

const Ticker = ({ticker}) => (
  <ul>
    <li>
      <h4 className="ng-binding">Last Price</h4>
      <strong className="ng-binding">
        <span
          className={
            ticker.cur_last_price_flag == "green"
              ? ""
              : "text-danger"
          }
        >
          {isNaN(ticker.cur_last_price) ? "0.00":new BigNumber(ticker.cur_last_price).toFormat(null, 1)}
        </span>
      </strong>
    </li>
    <li>
      <h4 className="ng-binding">24h-Change</h4>
      <strong>
        {" "}
        <span
          className={
            ticker.H24_change_int_flag == "green"
              ? ""
              : "text-danger"
          }
        >
          {isNaN(ticker.H24_change_int) ? "0.00":new BigNumber(ticker.H24_change_int).toFormat(null, 1)}
        </span>

        <span
          className={ 
            ticker.H24_change_per_flag== "green"
              ? ""
              : "text-danger"
          }
        
        >
          {isNaN(ticker.H24_change_per) ? "0.00":`(${new BigNumber(ticker.H24_change_per).toFormat(null, 1)})`}%
        </span>
      </strong>
    </li>
    <li>
      <h4 className="ng-binding">24h-High</h4>
      <strong className="ng-binding">
        {isNaN(ticker.H24_high)?"0.00": new BigNumber(ticker.H24_high).toFormat(null, 1)}
      </strong>
    </li>
    <li>
      <h4 className="ng-binding">24h-Low</h4>
      <strong className="ng-binding">
        {isNaN(ticker.H24_low)?"0.00": new BigNumber(ticker.H24_low).toFormat(null, 1)}
      </strong>
    </li>
    <li>
      <h4 className="ng-binding">24h Volume</h4>
      <strong className="ng-binding">
        {!isNaN(ticker.H24_vol)
          ? `${new BigNumber(ticker.H24_vol).toFormat(2, 1)}`
          : `0.00`}
      </strong>
    </li>
  </ul>
);

export default Ticker;
